module.exports = __webpack_public_path__ + "assets/img/quick-start-light.71bc493c.png";